export default "__VITE_ASSET__B7Z8XXz2__"